export default "__VITE_ASSET__BpHX8WHu__"